import { forwardRef, type HTMLAttributes, useId, useMemo } from 'react'

import { cn } from '@/lib/utils'

import { FormItemContext } from './FormFieldItemContext'

export const FormItem = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
  const id = useId()
  const value = useMemo(() => ({ id }), [id])

  return (
    <FormItemContext.Provider value={value}>
      <div ref={ref} className={cn('space-y-0.5', className)} {...props} />
    </FormItemContext.Provider>
  )
})
